import dynamic from 'next/dynamic';
import NextImage from '@/components/NextImage';
import EFEmail from '@/components/UI/svg/WTB/EFEmail';
import { updateBladeCalEmail } from '@/service/calculator';
import { useGlobal } from '@/utils/useGlobal';

const EmailModal = dynamic(() => import('./EmailSuccessModal'), { ssr: true });
export default function NotRecommended({ id }: any) {
    const { useLang, useState, useRouter, gtm, Link } = useGlobal();
    const { t } = useLang('bladecalculator');
    const { locale } = useRouter();
    const [inputValue, setInputValue] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [tip, setTip] = useState('');
    const [showModal, setShowModal] = useState(false);
    const onInput = (e: any) => {
        setInputValue(e?.target.value.trim());
        calDisable();
    };
    const calDisable = () => {
        const reg = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,10}$/;
        setDisabled(!reg.test(inputValue));
    };
    const onSubmit = async () => {
        try {
            const res = await updateBladeCalEmail({ email: inputValue, id }, locale);
            if (res?.code === '0') {
                setShowModal(true);
                tip && setTip('');
            }
            if (res?.code !== '0') {
                setTip(res?.message);
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'checklist_email_submit',
                product_name: 'EcoFlow BLADE',
                list_name: 'Results_Need Further Evaluation',
                button_name: t('detail.calculator_result_card2_submit'),
                status: res?.code === '0' ? 'success' : 'fail',
            });
        } catch (e: any) {
            console.error(e);
        }
    };
    return (
        <div className="need-further-evaluation result-box">
            <Link className="modal-close" href={'/blade-robotic-lawn-mower'}>
                &times;
            </Link>
            <div className="img-box">
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/result_evaluation.webp')}
                    src={require('@publicLocal/blade/calculator/pc/result_evaluation.png')}
                    alt={t('detail.calculator_result_card2_title')}
                    aria-label={t('detail.calculator_result_card2_title')}
                />
            </div>
            <p className="result-title">{t('detail.calculator_result_card2_title')}</p>
            <p className="result-text">{t('detail.calculator_result_card2_text')}</p>
            {/* 打开whatsapp聊天窗口 */}
            {/* <a className="result-btn" href={'https://api.whatsapp.com/send?phone=+1(626)271-0953'}>
                {t('detail.calculator_result_card2_btn')}
            </a> */}
            <div className="input-box">
                <div className="box-inner">
                    <input
                        type="text"
                        className="email"
                        value={inputValue}
                        placeholder={t('detail.calculator_result_card1_email_placeholder')}
                        onInput={onInput}
                    />
                    <span className="email-icon">
                        <EFEmail />
                    </span>
                </div>
                <button className="btn" disabled={disabled} onClick={onSubmit}>
                    {t('detail.calculator_result_card2_submit')}
                </button>
            </div>
            {tip && <p className="tip">{tip}</p>}
            {showModal && <EmailModal />}
        </div>
    );
}
